module.exports = __webpack_public_path__ + "img/product_42.04f5d52.webp";